import React from "react";
import { Button, Form, Input, Select, DatePicker } from "antd";
import { Col, Row, message } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { Date, Currency } from "../components/formatter";

const Search = (props) => {
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();

  const onFinish = (values) => {
    const { active } = props;

    if (active === "hotels") {
      localStorage.setItem("search", JSON.stringify(values));
      navigate("/results");
    }

    if (active === "expenses") {
      let reqData = JSON.parse(localStorage.getItem("reqData"));

      let newitem = {
        id: reqData.length + 1,
        requestDate: Date(),
        type: "Expense",
        expenseType: values?.expenseType,
        date: Date(values?.date),
        price: Currency(values?.price),
        status: "New",
      };

      reqData.push(newitem);
      localStorage.setItem("reqData", JSON.stringify(reqData));
      message.success("Request sent successfully.");

      props.handleUpdate(reqData);
    }
  };

  const handleChange = (value) => {
    console.log(value);
  };

  const locations = [
    { value: "Mysore", label: "Mysore" },
    { value: "Shimla", label: "Shimla" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "London", label: "London" },
    { value: "Singapore", label: "Singapore" },
    { value: "Bali", label: "Bali" },
  ];

  const { active } = props;

  return (
    <div style={{ minHeight: "88px" }}>
      {active === "hotels" && (
        <Form
          name="search"
          autoComplete="off"
          onFinish={onFinish}
          className="search-form"
          layout="vertical"
          initialValues={{
            location: "Mumbai",
            dates: [dayjs().add(10, "d"), dayjs().add(11, "d")],
            rooms: "1 Room, 2 Adults",
          }}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label="Location / City" name="location">
                <Select
                  placeholder="Location or City"
                  onChange={handleChange}
                  options={locations}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Check-in & Check-out" name="dates">
                <RangePicker format={"DD/MM/YYYY"} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Rooms & Guests" name="rooms">
                <Input placeholder="Rooms & Guests" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item className="btn-row" label=" ">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}

      {active === "expenses" && (
        <Form
          name="search"
          autoComplete="off"
          onFinish={onFinish}
          className="search-form"
          layout="vertical"
          initialValues={{
            expenseType: "Visa Fee",
            date: dayjs().add(10, "d"),
            price: "12000",
          }}
        >
          <Row gutter={24}>
            <Col span={10}>
              <Form.Item label="Expense Type" name="expenseType">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Date" name="date">
                <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="Total Price" name="price">
                <Input placeholder="Total Price" />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item className="btn-row" label=" ">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusOutlined />}
                >
                  Add
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}

      {(active === "flights" || active === "cars") && (
        <h5 className="text-center pt-4">Coming soon!</h5>
      )}
    </div>
  );
};

export default Search;
